import React from "react";
import FlowSteps from "./FlowSteps";
import {
  SCROLL_OFFSET,
  H2,
  BODY,
  LABEL,
  GRADIENT_TEXT,
  CONTAINER,
} from "./sections";

const TRADITIONAL_FLOW = [
  { label: "Speak" },
  { label: "Transcribe" },
  { label: "Edit manually" },
];

const AI_FLOW = [
  { label: "Speak" },
  { label: "Transcribe" },
  { label: "Refine" },
  { label: "Format" },
  { label: "Use", solid: true },
];

const VsDictationSection = () => {
  return (
    <section
      id="vs-dictation"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full"
    >
      <div
        className={`${CONTAINER} pt-[64px] pb-[64px] md:pt-[88px] md:pb-[88px] lg:pt-[112px] lg:pb-[112px]`}
      >
        <h2 className={`${H2} mx-auto max-w-[720px] text-center`}>
          AI Voice Typing Vs. Traditional Dictation
        </h2>

        <p className={`${BODY} mx-auto mt-[25.76px] max-w-[790px] text-center`}>
          The difference is easiest to see side by side. With traditional
          dictation you correct everything by hand. With an AI workflow, the
          editing and refinement stage is assisted, using prompts, a
          saved style, or no processing at all.
        </p>

        {/* The two pipelines, stacked */}
        <div className="mx-auto mt-[30.05px] flex max-w-[760px] flex-col gap-[12.88px]">
          <article className="rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-white px-[16px] py-[18px] sm:px-[24px] sm:py-[21.46px]">
            <p className={`${LABEL} text-center text-[#0A0D1699]`}>
              Traditional dictation
            </p>
            <div className="mt-[14px] flex justify-center">
              <FlowSteps steps={TRADITIONAL_FLOW} />
            </div>
          </article>

          <article className="rounded-[17.17px] border-[1.34px] border-[#3AB1F633] bg-[#EBF7FE] px-[16px] py-[18px] sm:px-[24px] sm:py-[21.46px]">
            <p className={`${LABEL} text-center`}>
              <span className={GRADIENT_TEXT}>AI voice typing</span>
            </p>
            <div className="mt-[14px] flex justify-center">
              <FlowSteps steps={AI_FLOW} tone="onTint" accentArrows />
            </div>
          </article>
        </div>

        <div className="mx-auto mt-[30.05px] flex max-w-[790px] flex-col gap-[25.76px] text-center">
          <p className={BODY}>
            The important difference is that AI can assist with the editing and
            refinement stage, using either ready-made prompts, a custom style
            you&apos;ve created, or no processing at all if you want the raw
            transcript.
          </p>
          <p className={BODY}>
            That&apos;s particularly useful for people who think faster than
            they type or who find it easier to explain an idea verbally than
            compose it word by word on a keyboard.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VsDictationSection;
